import React from 'react';
import ComponentSearchDomainForm from "../../../components/ComponentSearchDomainForm/ComponentSearchDomainForm";
import styles from './DomainHeader.scss';
import {__t} from '../../../common/lang/text-resource';
import OnlineDomainHeader from './OnlineDomainHeader';
import ComDomainHeader from './ComDomainHeader';


export default function DomainHeader({tld, xnOnly}) {

	if (tld == 'online') {
		return <OnlineDomainHeader tld={tld} xnOnly={xnOnly}/>;
	}

	if (tld == 'com') {
		return <ComDomainHeader tld={tld} xnOnly={false}/>;
	}

	const placeholder = xnOnly ? 'моятдомейн.' : 'mysupersite.';

	return (
	  <header className={styles.header}>
		  <div className={styles.innerHeader}>
			  <h1>{__t("Домейн .:tld", {tld: tld})}</h1>
			  <ComponentSearchDomainForm
				isTransparent={true}
				doNotCalcInputWidth={true}
				placeholder={placeholder + tld}
				animationPlaceholders={[placeholder + tld]}/>
		  </div>
	  </header>
	)
}